const prod = {
  "MAX_ATTACHMENT_SIZE": 5000000,
  "s3": {
    "APP_BUCKET": "blueprints-prod-app",
    "BUCKET": "blueprints-prod-upload"
  },
  "apiGateway": {
    "REGION": "ap-southeast-1",
    "URL": "https://drmzdfuro9.execute-api.ap-southeast-1.amazonaws.com/prod"
  },
  "cognito": {
    "REGION": "ap-southeast-1",
    "USER_POOL_ID": "ap-southeast-1_qHtRe5CIB",
    "APP_CLIENT_ID": "6e91gkjhhnl5m6sjv0tp7tk7eh",
    "IDENTITY_POOL_ID": "ap-southeast-1:783b67d1-ad92-4d65-8918-7f1b086e83d1"
  }
};

const dev = {
  "MAX_ATTACHMENT_SIZE": 5000000,
  "s3": {
    "APP_BUCKET": "edblueprints-dev-app",
    "BUCKET": "edblueprints-dev-upload"
  },
  "apiGateway": {
    "REGION": "ap-southeast-1",
    "URL": "https://jxfpk63kmb.execute-api.ap-southeast-1.amazonaws.com/dev"
  },
  "cognito": {
    "REGION": "ap-southeast-1",
    "USER_POOL_ID": "ap-southeast-1_7nWs1OMrz",
    "APP_CLIENT_ID": "550g06lnceivpvtadplahgfvh0",
    "IDENTITY_POOL_ID": "ap-southeast-1:8f1515d6-8d0b-4708-9e5c-73a161f5458a"
  }
};

export default (process.env.REACT_APP_STAGE === 'dev' ? dev : prod);


// WEBPACK FOOTER //
// ./src/config.js